import {Injectable} from '@angular/core';
Injectable();
export class UploadOptionType {
  action?: string;
  headerOptions?: Object;
  maxFileSize?: number;
  multiple?: boolean;
  accept?: string;
  method?: string;
  url: string;
  listType?: string;
  previewUrlPrex?: string;
  setParameter?: Object;
}
